<template>
  <ModalStructure @close="$emit('close')" :loading="loading">
    <div slot="title">Add New Page</div>
    <div slot="body">
      <SettingsRow title="Page Name">
        <div slot="left">
          <v-text-field
            label="Page name"
            v-model="name"
            placeholder="Page name"
            autocomplete="off"
            outlined
            dense
          ></v-text-field>
        </div>
        <div slot="right">
          Give your page a name to identify in your project. Only you can see
          it.
        </div>
      </SettingsRow>
      <v-divider></v-divider>
      <SettingsRow title="Page Name">
        <div slot="left">
          <v-text-field
            label="Page url"
            v-model="url"
            placeholder="/about"
            autocomplete="off"
            outlined
            dense
          ></v-text-field>
          <small>URL will be: {{ selectedProject.computedDomain + url }}</small>
        </div>
        <div slot="right">
          URL of your page. It must start with a slash ( / ).
        </div>
      </SettingsRow>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="tryCreatePage()" :loading="loading"
          >Create Page</v-btn
        >
      </v-card-actions>
    </div>
  </ModalStructure>
</template>

<script>
import { mapActions } from "vuex";
import projectMixin from "./project-mixin";

export default {
  components: {},
  mixins: [projectMixin],
  data() {
    return {
      name: "My Page",
      url: "/",
      type: "NORMAL",
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      createPage: "project/createPage",
    }),
    async tryCreatePage() {
      if (!this.name || !this.url) return;
      this.loading = true;
      var result = await this.createPage({
        name: this.name,
        url: this.url,
        type: this.type,
      });

      this.loading = false;

      if (!result) {
        return;
      }

      this.name = "";
      this.url = "/";
      setTimeout(() => {
        this.broadcastPageCreated();
        this.$emit("close");
      }, 500);
    },
  },
};
</script>

<style scoped>
.submenu {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background-color: #1975d2;
  padding-left: 10px;
  padding-right: 10px;
  z-index: 1;
}
</style>